import { useState, useEffect } from 'react';

const useImageSize = (image) => {
  const [imageWithSize, setImageWithSize] = useState(null);
  const [catchError, setCatchError] = useState(false);

  useEffect(() => {
    if (!image?.stream_url) return setImageWithSize(null);

    let cancelled = false;

    const getImageSize = (url) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () =>
          resolve({ width: img.naturalWidth, height: img.naturalHeight });
        img.onerror = reject;
        img.src = url;
      });

    getImageSize(image.stream_url)
      .then((size) => {
        if (!cancelled) {
          setImageWithSize({
            ...image,
            ...size,
          });
        }
      })
      .catch(() => {
        return setCatchError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [image?.stream_url]);

  return { catchError, imageWithSize };
};

export default useImageSize;
